var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckDoneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83784 13C4.56757 13 4.2973 12.8942 4.08108 12.6827L1.32432 9.98558C0.891892 9.5625 0.891892 8.92788 1.32432 8.50481C1.75676 8.08173 2.40541 8.08173 2.83784 8.50481L4.83784 10.4615L13.1622 2.31731C13.5946 1.89423 14.2432 1.89423 14.6757 2.31731C15.1081 2.74038 15.1081 3.375 14.6757 3.79808L5.59459 12.6827C5.37838 12.8942 5.10811 13 4.83784 13Z",
    fill: "#1A96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoneBlue);
export default __webpack_public_path__ + "static/media/check-done-blue.b6aa5fc9978e1f44adc5ee545b476445.svg";
export { ForwardRef as ReactComponent };